import React from 'react';
import classNames from 'classnames';

import Messages from './Messages';

const Airport = ({icao, name, closed, onToggle, ...props}) => (
    <li id={`airport-${icao}`} className={classNames('toggle', {closed})}>
        <h3>
            <a onClick={onToggle}>
                <span className="icao">{icao}</span>
                <span className="break" />
                <span className="name">{name}</span>
            </a>
        </h3>
        <Messages {...props} />
        <span className="toggle-icon" />
    </li>
);

export default Airport;
